const SRM = process.env.REACT_APP_SRM;

export const opportunityDetailUrl = id =>
  `${SRM}business-partner/opportunity/${id}/`;
